import { Component } from 'react';
export class AccountSetupFunctions extends Component {
  closeEditModalYes = () => {
    const {
      resetDirty,
      setSelectedTab,
      clearStudentInfo,
      getAccountSetup,
      setShowEditModal,
    } = this.props;
    setShowEditModal(false);
    this.setState({ showEditModal: false });
    resetDirty();
    setSelectedTab(0);
    clearStudentInfo();
    if (this.state.siteChange) {
      getAccountSetup();
    }
  };

  showWithdrawnChange = (e, data) => {
    this.props.getAccountSetup({
      ShowWithDrawn: data.checked,
    });
  };
}



// WEBPACK FOOTER //
// ./src/pages/accountsetup/AccountSetupFunctions.js